import React, { useEffect, useState } from "react";
import BreadCrumb from "../../components/BreadCrumb/BreadCrumb";
import Button from "../../components/Button/Button";
import CrmArraySort from "../../components/CrmArraySort/CrmArraySort";
import { DataPicker } from "../../components/DataPicker/DataPicker";
import Loading from "../../components/Loadings/LoadingTable";
import MarkerCard from "../../components/MarkerCard/MarkerCard";
import { SimpleSelect1 } from "../../components/SimpleSelect/SimpleSelect1";
import Typography from "../../components/Typography/Typography";
import {
  useFilterMarker,
  useGetCrmMarkerData,
  useGetCustomer,
} from "../../hooks/useCrm";
import { formatDate } from "../../utils/formatDate";
import { separate } from "../../utils/separate";
import { CrmMarkerStyle, Span } from "./CrmMarkerStyle";

const CrmMarker = () => {
  const { data: markerData, isLoading } = useGetCrmMarkerData();
  const [filteredData, setFilteredData] = useState();
  const [filter, setFilter] = useState({
    Start: null,
    End: null,
  });
  const {
    mutateAsync: filterMarker,
    data: markerFilteredData,
    isLoading: filteringData,
  } = useFilterMarker();
  useEffect(() => {
    setFilteredData(markerFilteredData);
  }, [markerFilteredData]);
  const handleFilter = async (data) => {
    await filterMarker(data);
  };

  const [count, setCount] = useState({
    sellers: false,
    sell: false,
  });

  const marker = (filteredData ? filteredData : markerData)?.data;
  const activities = (filteredData ? filteredData : markerData)?.data?.Activit;
  const sellers = (filteredData ? filteredData : markerData)?.data?.Seller;
  const LeadToCustomerTransferRate = (filteredData ? filteredData : markerData)
    ?.data?.LeadToCustomerTransferRate[0];

  const NumberOfEntriesUser = (filteredData ? filteredData : markerData)?.data
    ?.NumberOfEntriesUser[0];
  const MethodOfIntroductionSellonlines = (
    filteredData ? filteredData : markerData
  )?.data?.MethodOfIntroductionSellonlines;

  const MethodOfIntroductionSellOfflines = (
    filteredData ? filteredData : markerData
  )?.data?.MethodOfIntroductionSellOfflines;

  const howLoggedIn = (filteredData ? filteredData : markerData)?.data?.log[0];
  const methods = marker?.method;
  const activeuser = marker?.ActivePartners;
  const rank = marker?.Rank;
  const unsuccessful = marker?.UnsuccessfulOrder;
  const deleteReason = marker?.delete;

  return (
    <>
      {!isLoading ? (
        <CrmMarkerStyle>
          <BreadCrumb
            margin="mt-3"
            num1="واحد CRM"
            num2="گزارشگیری"
            num3="گزارشگیری"
            href1="/dashboard/crm"
            href2="/dashboard/crm/reporting"
          />
          <div className="row FilterBar">
            <div className="col-lg-3">
              <DataPicker
                onChange={(e) => setFilter({ ...filter, Start: formatDate(e) })}
                label={"از تاریخ"}
              />
            </div>
            <div className="col-lg-3">
              <DataPicker
                onChange={(e) => setFilter({ ...filter, End: formatDate(e) })}
                label={"تا تاریخ"}
              />
            </div>
            {/* <div className="col-lg-3">
              <SimpleSelect1
                label={"انتخاب مسئول"}
                res={customerResponsibleOptions}
              />
            </div> */}
            {/* <div className="col-lg-3 d-flex"> */}
            <Button
              bgColor="#009ef7"
              small="fit-content"
              color="#fff"
              size="12px"
              style={{ height: "fit-content", marginTop: "35px" }}
              className="mx-1"
              onclick={() => handleFilter(filter)}
            >
              اعمال فیلتر
            </Button>
            <Button
              bgColor="#f1416c"
              small="fit-content"
              color="#fff"
              size="12px"
              style={{ height: "fit-content", marginTop: "35px" }}
              className="mx-1"
              onclick={() => {
                setFilter(null);
                setFilteredData(null);
              }}
            >
              حذف فیلتر
            </Button>
            {/* </div> */}
          </div>
          {!filteringData ? (
            <div className="row">
              <div className="col-xl-4 col-12">
                <MarkerCard title="معاملات ورودی" onerow={true}>
                  <Typography className="card-data" color="#808080" size="14px">
                    <Span sndColor="#ffb400">
                      {marker?.Numberorder_offlines +
                        marker?.Numberorder_offlines_unsuccessfuls +
                        marker?.Numberorder_onlines}
                    </Span>
                    عدد
                  </Typography>
                  <Typography className="card-data" color="#808080" size="14px">
                    <Span sndColor="#ffb400">
                      {(
                        parseInt(marker?.Sumorder_offlines) +
                        parseInt(marker?.Sumorder_offlines_unsuccessfuls) +
                        parseInt(marker?.Sumorder_onlines)
                      ).toLocaleString()}
                    </Span>
                    تومان
                  </Typography>
                </MarkerCard>
                <MarkerCard
                  title="نحوه پخش معاملات ورودی"
                  scrollabel={true}
                  button={
                    <>
                      <Button
                        small="fit-content"
                        className="px-1 py-0 m-0 mx-1 "
                        size="10px"
                        bgColor="#f7f7f7"
                        style={{ border: "1px solid #d7d7d7" }}
                        hover={{ backgroundColor: "transparent" }}
                        onclick={() => setCount({ ...count, sell: true })}
                      >
                        تعداد
                      </Button>
                      <Button
                        small="fit-content"
                        className="px-1 py-0 m-0"
                        size="10px"
                        bgColor="#f7f7f7"
                        hover={{ backgroundColor: "transparent" }}
                        style={{ border: "1px solid #d7d7d7" }}
                        onclick={() => setCount({ ...count, sell: false })}
                      >
                        مبلغ
                      </Button>
                    </>
                  }
                >
                  <CrmArraySort
                    payload={sellers}
                    type={true}
                    sort={count.sell}
                    color={"#ffc107"}
                  />
                </MarkerCard>
                <MarkerCard title="فعالیت های انجام شده" scrollabel={true}>
                  <CrmArraySort
                    payload={activities}
                    type={false}
                    color={"#28a745"}
                  />
                </MarkerCard>
                <MarkerCard title="فعال ترین همکاران" scrollabel={true}>
                  <CrmArraySort
                    payload={activeuser}
                    type={false}
                    color={"#28a745"}
                  />
                </MarkerCard>
                <MarkerCard title="ثبت نامی های سایت" scrollabel={true}>
                  <Typography className="card-data" color="#808080" size="14px">
                    <span>ثبت نام از اپلیکیشن</span>{" "}
                    <Span sndColor="#00a572">
                      {NumberOfEntriesUser?.NumberApplicationUser}
                    </Span>
                    عدد
                  </Typography>
                  <Typography className="card-data" color="#808080" size="14px">
                    <span>ثبت نام از سی آر ام</span>{" "}
                    <Span sndColor="#00a572">
                      {NumberOfEntriesUser?.NumberCrmUser}
                    </Span>
                    عدد
                  </Typography>
                  <Typography className="card-data" color="#808080" size="14px">
                    <span>ثبت نام از وب ویو</span>{" "}
                    <Span sndColor="#00a572">
                      {NumberOfEntriesUser?.NumberWebViewUser}
                    </Span>
                    عدد
                  </Typography>
                  <Typography className="card-data" color="#808080" size="14px">
                    <span>ثبت نام از سایت</span>{" "}
                    <Span sndColor="#00a572">
                      {NumberOfEntriesUser?.NumberWebsiteUser}
                    </Span>
                    عدد
                  </Typography>
                </MarkerCard>
                <MarkerCard
                  title="فروش آنلاین بر اساس نحوه آشنایی"
                  scrollabel={true}
                >
                  {MethodOfIntroductionSellonlines?.map((item) => {
                    return (
                      <Typography
                        className="card-data"
                        color="#808080"
                        size="14px"
                      >
                        <span>{item.title}</span>{" "}
                        <Span sndColor="#00a572">{separate(item.value)}</Span>
                        تومان
                      </Typography>
                    );
                  })}
                </MarkerCard>
              </div>
              <div className="col-xl-4 col-12">
                <MarkerCard title="فروش موفق" onerow={true}>
                  <Typography className="card-data" color="#808080" size="14px">
                    <Span sndColor="#00a572">
                      {marker?.Numberorder_onlines +
                        marker?.Numberorder_offlines}
                    </Span>
                    عدد
                  </Typography>
                  <Typography className="card-data" color="#808080" size="14px">
                    <Span sndColor="#00a572">
                      {(
                        parseInt(marker?.Sumorder_offlines) +
                        parseInt(marker?.Sumorder_onlines)
                      ).toLocaleString()}
                    </Span>
                    تومان
                  </Typography>
                </MarkerCard>
                <MarkerCard
                  title="بهترین فروشنده ها"
                  scrollabel={true}
                  button={
                    <>
                      <Button
                        small="fit-content"
                        className="px-1 py-0 m-0 mx-1 "
                        size="10px"
                        bgColor="#f7f7f7"
                        style={{ border: "1px solid #d7d7d7" }}
                        hover={{ backgroundColor: "transparent" }}
                        onclick={() => setCount({ ...count, sellers: true })}
                      >
                        تعداد
                      </Button>
                      <Button
                        small="fit-content"
                        className="px-1 py-0 m-0"
                        size="10px"
                        bgColor="#f7f7f7"
                        hover={{ backgroundColor: "transparent" }}
                        style={{ border: "1px solid #d7d7d7" }}
                        onclick={() => setCount({ ...count, sellers: false })}
                      >
                        مبلغ
                      </Button>
                    </>
                  }
                >
                  <CrmArraySort
                    payload={sellers}
                    type={true}
                    sort={count.sellers}
                    color={"#28a745"}
                    feature={true}
                  />
                </MarkerCard>
                <MarkerCard title="بهترین شیوه های آشنایی" scrollabel={true}>
                  <CrmArraySort
                    payload={methods}
                    type={false}
                    color={"#28a745"}
                  />
                </MarkerCard>
                <MarkerCard title="رتبه بندی مشتریان" scrollabel={true}>
                  <CrmArraySort payload={rank} color={"#ffc107"} type={false} />
                </MarkerCard>
                <MarkerCard title="درصد تبدیل سرنخ به مشتری" scrollabel={true}>
                  <Typography className="card-data" color="#808080" size="14px">
                    <span>سرنخ</span>{" "}
                    <Span sndColor="#ffc107">
                      {LeadToCustomerTransferRate?.NumberSales_opportunities}
                    </Span>
                    عدد
                  </Typography>
                  <Typography className="card-data" color="#808080" size="14px">
                    <span>مشتری</span>{" "}
                    <Span sndColor="#ffc107">
                      {
                        LeadToCustomerTransferRate?.NumberSales_opportunitiesCustomer
                      }
                    </Span>
                    عدد
                  </Typography>
                  <Typography className="card-data" color="#808080" size="14px">
                    <span>نرخ تبدیل</span>{" "}
                    <Span sndColor="#ffc107">
                      {LeadToCustomerTransferRate?.LeadToCustomerTransferRateDarsad.toString().substring(
                        0,
                        2
                      )}
                    </Span>
                    درصد
                  </Typography>
                </MarkerCard>
                <MarkerCard
                  title="فروش آفلاین بر اساس نحوه آشنایی"
                  scrollabel={true}
                >
                  {MethodOfIntroductionSellOfflines?.map((item) => {
                    return (
                      <Typography
                        className="card-data"
                        color="#808080"
                        size="14px"
                      >
                        <span>{item.title}</span>{" "}
                        <Span sndColor="#ffc107">{separate(item.value)}</Span>
                        تومان
                      </Typography>
                    );
                  })}
                </MarkerCard>
              </div>
              <div className="col-xl-4 col-12">
                <MarkerCard title="معاملات شکست خورده" onerow={true}>
                  <Typography className="card-data" color="#808080" size="14px">
                    <Span sndColor="#dc3444">
                      {marker?.Numberorder_offlines_unsuccessfuls}
                    </Span>
                    عدد
                  </Typography>
                  <Typography className="card-data" color="#808080" size="14px">
                    <Span sndColor="#dc3444">
                      {parseInt(
                        marker?.Sumorder_offlines_unsuccessfuls
                      ).toLocaleString()}
                    </Span>
                    تومان
                  </Typography>
                </MarkerCard>
                <MarkerCard title="اصلی ترین دلایل شکست" scrollabel={true}>
                  <CrmArraySort
                    payload={unsuccessful}
                    color={"#dc3545"}
                    type={false}
                  />
                </MarkerCard>
                <MarkerCard title="تعداد مشتری ناراضی از همکاران" onerow={true}>
                  <Typography className="card-data" color="#808080" size="14px">
                    <Span sndColor="#dc3444">0</Span>
                    عدد
                  </Typography>
                </MarkerCard>
                <MarkerCard
                  title="فروش به تفکیک شهر"
                  onerow={true}
                  chart
                  filter={filter}
                >
                  <Typography className="card-data" color="#808080" size="14px">
                    <Span sndColor="#dc3444">
                      {parseInt(marker?.mashad).toLocaleString()}
                    </Span>
                    تومان فروش موفق مشهد
                  </Typography>
                  <Typography className="card-data" color="#808080" size="14px">
                    <Span sndColor="#dc3444">
                      {parseInt(marker?.nomashad).toLocaleString()}
                    </Span>
                    تومان فروش موفق غیر مشهد
                  </Typography>
                </MarkerCard>
                <MarkerCard title="دلایل حذف پرونده" scrollabel={true}>
                  <CrmArraySort
                    payload={deleteReason}
                    color={"#dc3545"}
                    type={false}
                  />
                </MarkerCard>
                <MarkerCard title="استفاده از اپلیکیشن" chart app>
                  <Typography className="card-data" color="#808080" size="14px">
                    <span>میزان استفاده</span>{" "}
                    <Span sndColor="#ffc107">{howLoggedIn?.log_use}</Span>
                    بار
                  </Typography>
                  <Typography className="card-data" color="#808080" size="14px">
                    <span>تعداد کابران</span>{" "}
                    <Span sndColor="#ffc107">{howLoggedIn?.log_user}</Span>
                    عدد
                  </Typography>
                </MarkerCard>
              </div>
            </div>
          ) : (
            <Loading />
          )}
        </CrmMarkerStyle>
      ) : (
        <Loading />
      )}
    </>
  );
};

export default CrmMarker;
